import { Injectable } from '@angular/core';
import * as beautify from 'js-beautify';
import * as _ from 'underscore';


@Injectable({
  providedIn: 'root'
})
export class Global {
  beautify: any;
  underscore: any;
  sqlFormatter: any;

  constructor() {
    this.beautify = beautify;
    this.underscore = _;
  }
}
